import { Card, TextField, FormControl, Button, useMediaQuery, useTheme, Box } from "@mui/material";
import { useSearchParams } from "react-router-dom";
import { useState, useEffect, useRef, useCallback } from "react";
import Translate from "../utils/Translate";
import Preloader from "../components/Preloader";
import Permits from "../components/actors/Permits";
import AddIcon from "@mui/icons-material/Add";
import ActorPermitFlowDialogContainer from "../components/actor-permits/ActorPermitFlowDialogContainer";
import SpeedMenu from "../components/SpeedMenu";
import SearchIcon from "@mui/icons-material/Search";
import ActorPermitFlowDialogHeader from "../components/actor-permits/ActorPermitFlowDialogHeader";
import MarketNotesList from "../components/actors/MarketNotesList";

const SearchField = ({ inputRef, defaultSearch }) => {
  const [query, setQuery] = useState(defaultSearch ?? "");

  return (
    <TextField
      inputRef={inputRef}
      slotProps={{ spellCheck: false }}
      fullWidth
      id="outlined-basic"
      label={Translate.get("Search")}
      variant="outlined"
      name="searchString"
      value={query}
      onChange={(evt) => setQuery(evt.target.value)}
    />
  );
};

export default function MarketNotesPage() {
  const [isLoading, setIsLoading] = useState(false);
  const [currentSearch, setCurrentSearch] = useState("");
  const searchFieldRef = useRef();
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));
  const [searchParams, setSearchParams] = useSearchParams();
  const defaultSort = searchParams.get("defaultSort");
  const defaultStdFilter = searchParams.get("std-filter");
  const defaultSearch = searchParams.get("defaultSearch");

  const finishedLoading = useCallback(() => {
    setIsLoading(false);
  }, []);

  useEffect(() => {
    // autofocus property on textfield did not work, what to do ;)
    const timer = setTimeout(() => searchFieldRef.current.focus(), 300);
    return () => clearTimeout(timer);
  }, []);

  const doSearch = useCallback(
    (searchText) => {
      if (!!defaultSearch && defaultSearch !== searchText) {
        // Clear the default stuff if the user changes the search
        setSearchParams({});
      }

      setCurrentSearch(searchText);
    },
    [defaultSearch, setSearchParams],
  );

  // Just load all permits initially (or perform defaultSearch from query params)
  useEffect(() => {
    doSearch(defaultSearch ?? "");
  }, [defaultSearch, doSearch]);

  function handleSubmit(event) {
    doSearch(searchFieldRef.current.value);
    event.preventDefault();
  }

  function handleReloadPermits() {
    doSearch(currentSearch);
  }

  const speedMenuActions = [
    {
      icon: <AddIcon />,
      text: Translate.get("CreateActorPermit"),
      dialogHeader: <ActorPermitFlowDialogHeader />,
      component: <ActorPermitFlowDialogContainer />,
    },
  ];

  return (
    <>
      {isLoading && <Preloader />}
      <Box display="flex" alignItems="center" flexWrap="wrap" gap={2} style={{ marginBottom: "1em" }}>
        <h2>{Translate.get("MarketNotes")}</h2>

        <FormControl sx={{ flex: 1, minWidth: { xs: "100%", sm: 300 } }}>
          <form className="actorsSearchForm" onSubmit={handleSubmit} style={{ display: "flex", width: "100%" }}>
            <SearchField inputRef={searchFieldRef} defaultSearch={defaultSearch} style={{ flex: 1 }} />

            {!isSmallScreen && (
              <Button type="submit" variant="contained" endIcon={<SearchIcon />} sx={{ ml: 1 }}>
                {Translate.get("Search")}
              </Button>
            )}
          </form>
        </FormControl>
      </Box>

      <Card>
        <MarketNotesList
          smallScreen={isSmallScreen}
          cardView={false}
          hideFilter={false}
          defaultSort={defaultSort}
          defaultStdFilter={defaultStdFilter}
          onReload={handleReloadPermits}
          searchText={currentSearch}
          onLoaded={finishedLoading}
          setIsLoading={setIsLoading}
        />
      </Card>
      {/* <SpeedMenu content={speedMenuActions} /> */}
    </>
  );
}
